export class OfferSignatureStatus {

    id: number = 0;
    code!: string;
    description!: string;
    active: boolean = false;
}